<template>
  <div id="registro" class="zindex10">
    <section id="fondo">
      <div class="container">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>
        <div class="row py-3">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>

        <div class="row">
          <div class="col-12 zindex10">
            <div class="row">
              <div class="col-12 z100">
                <div class="row py-5">
                  <div class="col-12 text-center py-4 pt-5 blanco zindex10">
                    <h2 class="blanco fXXG bold">GANADORES</h2>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center blanco zindex10">&nbsp;</div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 1</div>
                  <div class="col-12 fG bold">23 al 29 de marzo de 2026</div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <table
                      class="tableganadores"
                      border="1"
                      cellpadding="8"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Lugar</th>
                          <th>Incentivo</th>
                          <th>ID Único de Participante</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>IwTY22xqQohxiFLbLfXhaYaJXqE3</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>cAVIpvZVTMO7Og2my2PMHZRD6lF2</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>BonepWAMG0RgJ8sXFKxWhRU75DH3</td>
                        </tr>

                        <tr>
                          <td>4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>7unp7uUl2gWSL0UyfF8WVrqz8ir2</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>DCKgImcQtoWjJdXUfZwtCDRcKle2</td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>6fHzSHsaoQXJ2bxAdJMjpzQ9Rul1</td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>RgkE67j41FRb779BKBWCiCM9wke2</td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>QhVw0qIvekgKhgOVrx9AV8Fd6uC3</td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>8qQA0AQmRAcSPt4vG6AxrtQQDDC3</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>AwyiW03fPwUQp7oHqMc62jXlqev2</td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>tWoPQ9bEwRRBpzW6n059JFNGbfg1</td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>WhCNPrEfBmb1aVHlfBDNEjCjgnr2</td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>EV3QNKR9t2gPFrhdzpWkjkzNaUW2</td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>M9KbQ3kbVHYcscpGniXuRKRRuqC3</td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>fYzLXWNnIrWqAfBS5rChXTaOqT42</td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>eWuipCrlymhlCEmacNtft4ZylpU2</td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>JiQUBHRwaROslXSLONwEGs16jRg1</td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>2QhEhDJL65OvRUld7YtWzZLExuD2</td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>XRcPvNClHcU24od5ajEjX3WlBe32</td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>HyLfPPlqNuS3G35AKNDJBNHy4S33</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center blanco zindex10">&nbsp;</div>
                </div>

                <div class="row blanco text-center">
                  <div class="col-12 fXG bold">SEMANA 2</div>
                  <div class="col-12 fG bold">
                    30 de marzo al 05 de abril de 2026
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    
                    <table
                      border="1"
                      cellpadding="8"
                      cellspacing="0"
                      class="tableganadores"
                    >
                      <thead>
                        <tr
                          style="
                            background-color: #009fe3;
                            color: #fff;
                            text-align: center;
                          "
                        >
                          
                          <th>Lugar</th>
                          <th>Incentivo</th>
                          <th>ID Único de Participante</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                         
                          <td style="text-align: center">1</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>lXKT4SZsfRh9KKJUouVUTeTj5UG2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">2</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>jbyj5OTL78axR7gkpovjtT6H96v1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">3</td>
                          <td>
                            PANTALLA MARCA HISENSE SMART TV QLED DE 55 PULGADAS
                            4K/UHD CON AI SMOOTH MOTION
                          </td>
                          <td>GvN5rG4SEWguWa7lPGXXxqOFGvh1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">4</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>yQGlVlTU2dctVuP9yAVfBSLfpce2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">5</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>gWVV0vLvjvdFheyqJqAGdcZkxmI2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">6</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>V14EutiAebOy3K05729boDQdYTK2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">7</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>ySamnSeJPUXwhG9TULo5QD7OG3g1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">8</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>zgHwQtUqVWYWHRvkAfQ61Epf1Fo1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">9</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>PxaG7JBrqofD33eDWBU3HrwlkPG2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">10</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>MjoAP2HQLoRrmsl5Z2TQbNv32So1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">11</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>S94QaMru2sXj81TLtyt0M3h6Rzf1</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">12</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>uH4ARD0zaEYiUQUxNcmG1pL61go2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">13</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>dwUVftyoLwdIVo38forsJBJvthu2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">14</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>3iry3w1bbig81wYm9YPLWUztjd83</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">15</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>qMQqzTzz69OOLQcSPswhRNsuay43</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">16</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>rMKOeWgRAGeovtgtjBP00pjcgV73</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">17</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>hVPD4YvVuMYvi0idl5TlfXEqKYj2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">18</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>K5MGBM2FehT7pqwpCNRV8hHxJsV2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">19</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>Ct5t7M6I8BcHed4Y0uCoazgsZNV2</td>
                        </tr>
                        <tr>
                          <td style="text-align: center">20</td>
                          <td>
                            JERSEY SELECCIÓN NACIONAL DE MÉXICO MARCA ADIDAS O
                            MONEDERO ELECTRÓNICO CON VALOR DE $2000.00 PESOS
                          </td>
                          <td>CsdiO8EDyFYIIcbNQmIAgFp2Bvu2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">DORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de dores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/dores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de dores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // Validar edad (18 años o más)
      if (!this.signupForm.fecha_nacimiento) {
        swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
        return false;
      }

      const fechaNacimiento = moment(
        this.signupForm.fecha_nacimiento,
        "YYYY-MM-DD"
      );
      const hoy = moment();
      const edad = hoy.diff(fechaNacimiento, "years");

      if (edad < 18) {
        swal.fire(
          "Oops",
          "Debes tener al menos 18 años para registrarte.",
          "warning"
        );
        return false;
      }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
